import { render, staticRenderFns } from "./RevCard.vue?vue&type=template&id=9f737a0e&scoped=true"
import script from "./RevCard.vue?vue&type=script&lang=js"
export * from "./RevCard.vue?vue&type=script&lang=js"
import style0 from "./RevCard.vue?vue&type=style&index=0&id=9f737a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f737a0e",
  null
  
)

export default component.exports